import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { ActionType, ProColumns, ProForm, ProFormDatePicker } from "@ant-design/pro-components";
import { Button, Card, DatePicker, Form } from "antd";


import { AntDProTable } from "../../../components/antdProTable";

import { SubscriptionSchema } from "../../../model/subscriptionSchema.schema";
import { subscriptionService } from "../../../services/subscriptionService";
import dayjs from "dayjs";

//Start
export function AllSubscriptionSummaryPage(prop: { subscription: string }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false)
  let tableRef = useRef<ActionType>();

  const columns: ProColumns<SubscriptionSchema>[] = [
    {
      title: t("Action"),
      dataIndex: "action",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
    },
    {
      title: t("Year"),
      dataIndex: "year",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
    },
    {
      title: t("Month"),
      dataIndex: "month",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
    },
    {
      title: t("Count"),
      dataIndex: "count",
      hideInSearch: true,
      defaultSortOrder: "descend",
      hideInTable: false,
      sorter: false,

    }
  ];

  return (
    <>
      <Card>

        <Form
          name="customized_form_controls"
          layout="inline"
          disabled={downloading}
          onFinish={async ({ month }) => {
            setDownloading(true)
            try {
              const response = await subscriptionService
                .downloadSubscriptionSummary(prop.subscription, month)
             
              const url = window.URL.createObjectURL(new Blob([response.data]));

              // Create a link element
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', month.format("YYYY-MM")+'.xlsx'); // Specify the file name

              // Append to the body and trigger the download
              document.body.appendChild(link);
              link.click();

              // Clean up
              link.remove();
              window.URL.revokeObjectURL(url);
            } catch (err) {

            } finally {
              setDownloading(false)
            }
          }}
          initialValues={{
            month: dayjs(),
          }}
        >
          <Form.Item name={"month"} label="Report Month">
            <DatePicker allowClear={false} picker="month" minDate={dayjs().add(-3, "year")} maxDate={dayjs()} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Download
            </Button>
          </Form.Item>
        </Form>

      </Card>
      <Card style={{ marginTop: 20 }} loading={loading}>
        <AntDProTable<SubscriptionSchema>
          filterType={"light"}
          size={"small"}
          onRefCallback={(ref: any) => {
            tableRef.current = ref.current;
          }}
          columns={columns}
          rowKey="id"
          scroll={{ x: "max-content" }}
          pagination={false}
          request={(
            params,
            sort,
            filter,
            skip,
            take,
            where,
            sortBy,
            order,
            cb
          ) => {
            /// setLoading(true);
            where.subscription = prop.subscription;
            subscriptionService
              .listAllSubscriptionSummary(prop.subscription)
              .then((res) => {
                //setLoading(false);
                if (res.success) {
                  cb({
                    data: res.result,
                    success: true,
                  });
                } else {
                  cb({
                    data: [],
                    success: false,
                  });
                }
              })
              .catch((err) => {
                setLoading(false);
                cb({
                  data: [],
                  success: false,
                });
              });
          }}
        />
      </Card>
    </>
  );
}
